import React from 'react';
import { TabbedOverviewPage } from '../components/OverviewSections.comp';
import { PriorityActionsSection } from '../../SchoolDashboard/pages/MethodologyPriorityActions.page';

/* How Priority Actions Are Triggered — a common slide (Seongmin, 22 Sep: static
   front-end text; Ian's slide is the definitive source). Ian's Common Section
   deck (16 Sep), DB-CS-P0,P1-All-PriorityActionGuide, p.19, is one slide for
   PD, ND, SND and SD alike and points to the same guide document, so the
   Network dashboard shows exactly the School dashboard's content (Action Plan
   Families PL / PE / TE / SS and each family's Full Action Plan). It replaces
   the older SND-deck version, whose extra "Assessment Package" family is not
   in the guide or in the datahouse's action families. */
const MethodologyPriorityActionsPage = () => (
    <TabbedOverviewPage
        skipNoDataGate
        tabs={[
            {
                label: 'How Priority Actions Are Triggered',
                content: <PriorityActionsSection/>,
            },
        ]}
    />
);

export default MethodologyPriorityActionsPage;
